import { ApartmentOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import {
	Button,
	Card,
	Col,
	Divider,
	Empty,
	Row,
	Spin,
	Statistic,
	Table,
	Tag,
	Typography,
} from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { getProductLines } from "../../services/productLinesService";

const { Title, Text } = Typography;

const ProductLines = ({ product, onBack }) => {
	const [loading, setLoading] = useState(true);
	const [productLines, setProductLines] = useState([]);

	const loadProductLines = useCallback(async () => {
		if (!product || !product.No) {
			setLoading(false);
			return;
		}

		try {
			setLoading(true);
			const lines = await getProductLines(product.No);
			setProductLines(lines);
		} catch (error) {
			window.messageApi.error(
				`Error al cargar las líneas del producto: ${error.message}`
			);
		} finally {
			setLoading(false);
		}
	}, [product]);

	useEffect(() => {
		loadProductLines();
	}, [loadProductLines, product]);

	const columns = [
		{
			title: "No.",
			dataIndex: "No",
			key: "No",
			width: "15%",
		},
		{
			title: "Línea No.",
			dataIndex: "Line_No",
			key: "Line_No",
			width: "10%",
			sorter: (a, b) => a.Line_No - b.Line_No,
		},
		{
			title: "Tipo",
			dataIndex: "Type",
			key: "Type",
			width: "10%",
			render: (type) => {
				let color = type === "Producto" ? "blue" : "orange";
				return <Tag color={color}>{type}</Tag>;
			},
		},
		{
			title: "Descripción",
			dataIndex: "Description",
			key: "Description",
			width: "35%",
		},
		{
			title: "Cantidad",
			dataIndex: "Quantity_per",
			key: "Quantity_per",
			width: "10%",
			render: (qty, record) => `${qty} ${record.Unit_of_Measure_Code}`,
		},
		{
			title: "Variante",
			dataIndex: "Variant_Code",
			key: "Variant_Code",
			width: "10%",
			render: (code) => code || "-",
		},
	];

	if (loading) {
		return <Spin size="large" />;
	}

	return (
		<Card
			title={
				<div style={{ display: "flex", alignItems: "center" }}>
					<ApartmentOutlined
						style={{ fontSize: "24px", marginRight: "10px" }}
					/>
					<span>Kit de Producto</span>
				</div>
			}
			extra={
				<Button type="primary" icon={<ArrowLeftOutlined />} onClick={onBack}>
					Volver a Productos
				</Button>
			}
		>
			<Row gutter={[16, 16]}>
				<Col span={24}>
					<Card bordered={false} style={{ background: "#f5f5f5" }}>
						<Title level={4}>Detalles del Producto</Title>
						<Row gutter={16}>
							<Col span={8}>
								<Statistic
									title="No. de Producto"
									value={product.No || "Sin asignar"}
								/>
							</Col>
							<Col span={8}>
								<Statistic title="Descripción" value={product.description} />
							</Col>
							<Col span={8}>
								<Statistic
									title="Precio Unitario"
									value={
										product.Unit_Price ? product.Unit_Price.toFixed(2) : "0.00"
									}
									suffix="$"
								/>
							</Col>
						</Row>
					</Card>
				</Col>

				<Col span={24}>
					<Divider orientation="left">
						<Text strong>Componentes del Kit ({productLines.length})</Text>
					</Divider>

					{productLines.length === 0 ? (
						<Empty
							description={
								<span>
									Este producto no tiene componentes de kit asociados
									<br />
									<Text type="secondary">
										Los componentes del kit se sincronizan desde Business
										Central
									</Text>
								</span>
							}
							image={Empty.PRESENTED_IMAGE_SIMPLE}
						/>
					) : (
						<Table
							columns={columns}
							dataSource={productLines.map((line) => ({
								...line,
								key: line.id,
							}))}
							pagination={{ pageSize: 10 }}
							bordered
							size="middle"
							scroll={{ x: "max-content" }}
						/>
					)}
				</Col>
			</Row>
		</Card>
	);
};

export default ProductLines;
